// @ts-nocheck
import * as React from 'react';
import { useEffect } from 'react';
import { getUsage } from '../../features/usage/usage_service';
import { useObservable } from '@ngneat/react-rxjs';
import { token$ } from '../../features/auth/auth_repository';
import { activeService$ } from '../../features/user/user_repository';
import { usage$ } from '../../features/usage/usage_repsitory';
import { Progress } from '../../ui_components/progress/progress';

function Usage() {
    const [token] = useObservable(token$);
    const [activeService] = useObservable(activeService$);
    const [usage] = useObservable(usage$);

    useEffect(() => {
        if (activeService) {
            getUsage(
                {
                    serviceId: activeService.service_id,
                },
                token
            );
        }
    }, [activeService, token]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat(navigator.language).format(date);
    };

    const usageStart = activeService?.plan?.usage_start;
    const usageEnd = activeService?.plan?.usage_end;

    return (
        <>
            <div className={'mb-2'}>
                <div className="flex flex-col gap-2">
                    <div className={'usage__question-limit'}>
                        <p className="text-xs">
                            Questions usage: {usage.questionsUsage} /{' '}
                            {usage.questionsLimit}
                        </p>

                        <Progress
                            className={'h-3'}
                            value={
                                (usage.questionsUsage * 100) /
                                usage.questionsLimit
                            }
                        />
                    </div>
                    <div className={'usage__documents-limit'}>
                        <p className="text-xs">
                            Documents usage: {usage.documentsUsage} /{' '}
                            {usage.documentsLimit}
                        </p>
                        <Progress
                            className={'h-3'}
                            value={
                                (usage.documentsUsage * 100) /
                                usage.documentsLimit
                            }
                        />
                    </div>
                </div>
                {usageStart && usageEnd && (
                    <div className="mt-1">
                        <p className="text-xs text-muted-foreground">
                            Usage period: {formatDate(usageStart)} -{' '}
                            {formatDate(usageEnd)}
                        </p>
                    </div>
                )}
            </div>
        </>
    );
}

export default Usage;
